import { useEffect, useMemo, useState, type PropsWithChildren } from 'react'

import {
  DocumentTitleContext,
  formatDocumentTitle,
  type DocumentTitleContextValue
} from './DocumentTitle'

export const DocumentTitleProvider = ({ children }: PropsWithChildren) => {
  const [section, setSection] = useState<string>()
  const [override, setOverride] = useState<string>()
  const [app, setApp] = useState<string>()

  useEffect(() => {
    document.title = formatDocumentTitle(override, section, app)
  }, [app, override, section])

  const value = useMemo<DocumentTitleContextValue>(
    () => ({ setApp, setOverride, setSection }),
    []
  )

  return (
    <DocumentTitleContext.Provider value={value}>
      {children}
    </DocumentTitleContext.Provider>
  )
}
